import Constant from "../constants";
import { mainWrapper } from "./main";

const ContentService = {
    faq,
    aboutUs,
};

function faq(params) {
    return mainWrapper.get(Constant.host + "/faq", params);
}

function aboutUs() {
    return mainWrapper.get(Constant.host + "/about-us");
}

export default ContentService;
